import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { SavingsMeasure, PagedResponseSavingsMeasure } from '../models/SavingsMeasure';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class SavingsMeasureService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getSavingsMeasures():Observable<PagedResponseSavingsMeasure>{
    const data =  this.http.get<PagedResponseSavingsMeasure>(this.APIURL+'/SavingsMeasure' + '?PageNumber=1&PageSize=50');
    this.messageService.add('SavingsMeasure Service: fetched SavingsMeasures');
    return data;
  }

  getSavingsMeasure(id: number): Observable<SavingsMeasure> {
        const SavingsMeasure =this.http.get<SavingsMeasure>(this.APIURL+'/SavingsMeasure/' + id);
    this.messageService.add(`SavingsMeasure Service: fetched SavingsMeasure with id=${id}`);
    return SavingsMeasure;
  }
}